module.exports = __webpack_public_path__ + "img/masteres.2a4b02c8.jpg";